export enum ENV_NAMES {
  LOCAL = "local",
  DEV = "dev",
  STAGING = "staging",
  PROD = "prod",
  UNKNOWN = "unknown-env",
}

const getEnvFromHostname = (hostname: string): ENV_NAMES => {
  switch (hostname) {
    case "portal.dev.fronterahealth.com":
      return ENV_NAMES.DEV;
    case "portal.staging.fronterahealth.com":
      return ENV_NAMES.STAGING;
    case "portal.fronterahealth.com":
      return ENV_NAMES.PROD;
    case "localhost":
      return ENV_NAMES.LOCAL;
    default:
      return ENV_NAMES.UNKNOWN;
  }
};

const getBackendEnv = (): ENV_NAMES => {
  const endpoint =
    import.meta.env.VITE_REAL_FRONTERA_GRAPHQL_ENDPOINT || import.meta.env.VITE_FRONTERA_GRAPHQL_ENDPOINT;
  if (endpoint?.includes("localhost") || endpoint?.includes("127.0.0.1")) {
    return ENV_NAMES.LOCAL;
  } else if (endpoint?.includes("dev.us-west-2.foundational.frontera.health")) {
    return ENV_NAMES.DEV;
  } else if (endpoint?.includes("staging.us-west-2.foundational.frontera.health")) {
    return ENV_NAMES.STAGING;
  } else if (endpoint?.includes("prod.us-west-2.foundational.frontera.health")) {
    return ENV_NAMES.PROD;
  }
  return ENV_NAMES.UNKNOWN;
};

export const BACKEND_ENV = getBackendEnv();

const getTracingUrlFromHostname = (
  hostname: string,
):
  | "https://dev.us-west-2.foundational.frontera.health/graphql/"
  | "https://prod.us-west-2.foundational.frontera.health/graphql/"
  | "https://staging.us-west-2.foundational.frontera.health/graphql/"
  | undefined => {
  switch (hostname) {
    case "portal.dev.fronterahealth.com":
      return "https://dev.us-west-2.foundational.frontera.health/graphql/";
    case "portal.staging.fronterahealth.com":
      return "https://staging.us-west-2.foundational.frontera.health/graphql/";
    case "portal.fronterahealth.com":
      return "https://prod.us-west-2.foundational.frontera.health/graphql/";
    case "localhost":
      return undefined;
    default:
      return undefined;
  }
};

const getCookieDomainFromHostname = (
  hostname: string,
):
  | ".dev.fronterahealth.com"
  | ".staging.fronterahealth.com"
  | ".fronterahealth.com"
  | ".local.fronterahealth.com"
  | ".unknown-cookie.fronterahealth.com" => {
  switch (hostname) {
    case "portal.dev.fronterahealth.com":
      return ".dev.fronterahealth.com";
    case "portal.staging.fronterahealth.com":
      return ".staging.fronterahealth.com";
    case "portal.fronterahealth.com":
      return ".fronterahealth.com";
    case "localhost":
      return ".local.fronterahealth.com";
    default:
      console.error("Unexpected hostname, this should not happen");
      return ".unknown-cookie.fronterahealth.com";
  }
};

const hostname = globalThis.location?.hostname ?? "localhost";

export const APP_ENV = getEnvFromHostname(hostname);
export const tracingUrl = getTracingUrlFromHostname(hostname);
export const cookieDomain = getCookieDomainFromHostname(hostname);
